import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../services/apiService';

export const loginUser = createAsyncThunk('auth/loginUser', async (credentials, { rejectWithValue }) => {
  try {
    credentials.username = credentials.username.toUpperCase();
    const response = await api.post('/auth/login', credentials);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.details || 'Error de autenticación');
  }
});